const firebaseConfig = {
  apiKey: "AIzaSyAfqSzE6P1YkHsJJplMgXLSIJLolkdbhc0",
  authDomain: "home-painting-d9605.firebaseapp.com",
  projectId: "home-painting-d9605",
  storageBucket: "home-painting-d9605.appspot.com",
  messagingSenderId: "440295843590",
  appId: "1:440295843590:web:408827037526072cca2087"
};

export default firebaseConfig;